import { saveAs } from 'file-saver'
import axios from 'axios'
import $http from '@/libs/axios'
import FormsService from '@/services/forms-service'

class QRAPIs {
  static cancelTokenSource: any = null

  public static async update(payload: any) {
    const body = FormsService.convertObjectToFormData(payload)
    body.append('_method', 'put')
    return (await $http.post('/qr/update', body)).data
  }

  public static async remove(id: number) {
    return (await $http.delete(`/qr/delete/${id}`)).data
  }

  public static async create(payload: any) {
    const body = FormsService.convertObjectToFormData(payload)
    return (await $http.post('/qr/create', body)).data
  }

  public static async getDependencies(branchId: number) {
    return (await $http.get(`/qr/dependencies/${branchId}`)).data
  }

  public static async download(Id: string, name: string) {
    const file = (await $http.get(`/qr/download/${Id}`, { responseType: 'blob' })).data
    saveAs(file, name)
  }

  static async previewQR(setting: any) {
    try {
      if (QRAPIs.cancelTokenSource !== null) {
        QRAPIs.cancelTokenSource.cancel()
      }
      QRAPIs.cancelTokenSource = axios.CancelToken.source()

      const body = FormsService.convertObjectToFormData(setting)
      const { data } = await $http.post('/qr/preview', body, { cancelToken: QRAPIs.cancelTokenSource.token })
      QRAPIs.cancelTokenSource = null
      return data.qr
    } catch (error) {
      if (!axios.isCancel(error)) {
        throw error
      }
      return null
    }
  }

  static async quickAccessQR(branchId: number) {
    return (await $http.get(`/qr?branch_id=${branchId}&download=0&_t=${new Date().getTime()}`)).data.qr
  }
}

export default QRAPIs
